import PropTypes from 'prop-types';
import React from 'react';
import { Image, View, StyleSheet } from 'react-native';
import { ActivityIndicator, Text } from 'trpc-react-native-ui';
import SecondaryFullButton from '../FullButtons/SecondaryFullButton';
import theme from '../../../theme-config';
import Icon from '../Icon/Icon';

const modalBottom = props => {
  const styles = getStyles();
  if (props.button) {
    return (
      <SecondaryFullButton text={props.button} style={styles.footerButton} onPress={props.callback} />
    );
  }
  if (theme.footerImage) {
    return <Image resizeMode="cover" style={styles.footerImage} source={theme.footerImage} />;
  }
  return <View style={styles.footerImage} />;
};

const RequestStatusModalBody = props => {
  const styles = getStyles();
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <View style={styles.iconContainer}>
          <Icon name={props.icon} style={styles.icon} />
        </View>
        <View>
          <Text style={styles.title}>{props.title}</Text>
          <Text style={styles.description}>{props.text}</Text>
        </View>
      </View>
      <View style={styles.footer}>{props.isLoading && <ActivityIndicator />}</View>
      {modalBottom(props)}
    </View>
  );
};

function getStyles() {
  const MODAL_BODY_HEIGHT = 200;
  const BORDER_RADIUS = 5;
  return StyleSheet.create({
    container: {
      height: MODAL_BODY_HEIGHT,
      backgroundColor: 'white',
      borderRadius: BORDER_RADIUS,
      paddingTop: 20,
    },
    content: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 20,
    },
    title: {
      fontSize: 17,
      fontWeight: '600',
      color: '#787878',
    },
    description: {
      fontSize: 13,
      color: '#A1A1A1',
    },
    iconContainer: {
      height: 50,
      width: 50,
      borderRadius: 50 / 2,
      backgroundColor: theme.tertiaryColor,
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: 20,
      marginLeft: 0,
    },
    icon: {
      fontSize: 24,
      color: 'white',
    },
    footer: {
      alignItems: 'stretch',
    },
    footerImage: {
      height: 60,
      width: null,
      borderRadius: BORDER_RADIUS,
    },
    footerButton: {
      marginHorizontal: 20,
      marginVertical: 10,
    },
  });
}

RequestStatusModalBody.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  icon: PropTypes.string.isRequired,
  button: PropTypes.string,
  callback: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default RequestStatusModalBody;
